<div class="planbordscherm" #planbordscherm>
  <div class="planbord_overview" *ngIf="ux.weergave === 'project'">
    <div class="naamcel"></div>
    <div class="itemlayer">
      <div *ngFor="let datestr of datumstrings"
           class="datumcontainer">
        <ng-container *ngFor="let planitem of itemsPerDateGefilterd[datestr]">
          <planblock [planitem]="planitem" [visual]="true"
                     *ngIf="planitem.project.factureerbaar && ((! ux.projectfilter) || planitem.project.id === ux.projectfilter) && (ux.weergave === 'project' || planitem.implemented > 0) &&  (planitem.implementationDegree !== 0 || ((! isLeverancier) && planitem.heeftKritiek))"
                     [weergave]="ux.weergave"
                     [attr.planitem]="planitem.id"
                     data-display="visual"
                     (edit)="gotoPlanitem(planitem)"></planblock>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="planbordcontent" #planbordscroller sihw-drag-to-scroll
       (dragging-start)="ux.dragging = true" (dragging-end)="ux.dragging = false">
    <div class="planbord">
      <div class="nu_lijn" *ngIf="nuLijn !== null" [title]="nu.format('HH:mm')"
           [ngStyle]="{left: 'calc(14rem + ((100% - 14rem) * ' + nuLijn + '))'}"></div>
      <div #planbordheader class="planbord_header">
        <div class="planbord_header_naam naamcel" #naamcel>
          Planning
        </div>
        <div class="planbord_header_datum" [attr.data-blokindex]="index"
             *ngFor="let date of datums; let index=index;"
             title="wk {{date.format('ww')}} - {{date.format('dd D-M-YYYY')}}">
          <span>{{ date.format('dd D-M') }}</span>
          <span class="planbord_weeknummer"
                *ngIf="index === 0 || date.isoWeekday() === 1">{{ date.format("ww") }}</span>
        </div>
      </div>

      @switch (ux.weergave) {
        @case ('project') {

          <!--      Weergave DIENSTEN. We filteren qua weergave met ngIf, om zo weinig mogelijk rekentijd over te
                  houden in de DOM-->
          <ng-container *ngFor="let klant of klanten">
            <!-- Alleen klanten met pi -->
            <ng-container
              *ngIf="toonKlantInOverzicht(klant)">
              <div class="planbord_rijblok klant">
                <div class="planbord_rijblok_hoofdrij">
                  <div class="planbord_rijblok_naam klantnaam naamcel"
                       [class.open]="ux.klantnaamOpened[klant.klantnaam]"
                       [title]="klant.klantnaam" (click)="toggleKlantnaamOpened(klant.klantnaam)">{{ klant.klantnaam }}
                    <span
                      *ngIf="klant.projecten.length && ! ux.projectfilter"
                      class="ml-1 fas"
                      [class.fa-caret-down]="! ux.klantnaamOpened[klant.klantnaam]"
                      [class.fa-caret-up]="ux.klantnaamOpened[klant.klantnaam]"></span>
                  </div>
                  <ng-container *ngFor="let _datestr of datumstrings">
                    <div class="planbord_rijblok_datum dagblokken"></div>
                  </ng-container>
                </div>
              </div>
              @if (ux.klantnaamOpened[klant.klantnaam] || ux.projectfilter) {
                <!-- Als er een projectfilter is loopen we altijd over de projecten, want dan moet de goede zich
                  tonen
                -->
                @for (project of klant.projecten; track project.id) {
                  @if ((((!ux.projectfilter) && (project._tags['heeft_pi'])) || project.id === ux.projectfilter) && (! project.externe_werkmaatschappij)) {
                    <div class="planbord_rijblok project">
                      <div class="planbord_rijblok_hoofdrij">
                        <div class="planbord_rijblok_naam projectnaam naamcel"
                             (click)="toggleProjectOpened(project)"
                             [title]="project.naam">
                          <span class="iconengroep">
                            <span class="fas fa-exclamation-triangle text-warning"
                                  *ngIf="project.heeftKritiek"
                                  [title]="project.kritiekTekst"></span>
                          </span>
                          <span class="projectlabel">{{ project.label }}</span>
                          <span
                            *ngIf="project?._tags['functionlist']?.length"
                            class="ml-1 fas"
                            [class.fa-caret-down]="! ux.projectOpened[project.id]"
                            [class.fa-caret-up]="ux.projectOpened[project.id]"></span>
                          <div class="herorderknop" title="Sorteer de functies op naam"
                               *ngIf="ux.projectOpened[project.id] && project._tags['functionlist'].length > 1"
                               (click)="heroderfuncties(project, $event)"><span class="fas fa-sort"></span></div>
                        </div>
                        <ng-container *ngFor="let datestr of datumstrings; let index=index;">
                          <div class="planbord_rijblok_datum dagblokken projectcel"
                               [attr.data-blokindex]="index">
                            <ng-container
                              *ngIf="(! ux.dragging) && canAddPlanitems && (! project.externe_werkmaatschappij) && datestr >= project.begindatum && ((! project.einddatum) || datestr <= project.einddatum)">
                              <div class="addblockbtn morning" [title]="'Voeg dagdienst toe voor ' + project.naam"
                                   (click)="addPlanItem(project, datestr, 'morning' )"><span
                                class="fas fa-plus-circle"></span></div>
                              <div class="addblockbtn evening" [title]="'Voeg avonddienst toe voor ' + project.naam"
                                   (click)="addPlanItem(project, datestr, 'evening' )"><span
                                class="fas fa-plus-circle"></span></div>
                              <div class="addblockbtn night" [title]="'Voeg nachtdienst toe voor ' + project.naam"
                                   (click)="addPlanItem(project, datestr, 'night' )"><span
                                class="fas fa-plus-circle"></span></div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </div>
                      <ng-container *ngIf="ux.projectOpened[project.id]">
                        <ng-container
                          *ngFor="let fd of project._tags['functionlist']; let index = index; let first = first; let last = last;">
                          <ng-container *ngFor="let rownr of fd.rowlist; let lastrow = last;">
                            <div class="planbord_rijblok_subrij" [class.extrarow]="rownr > 0" planblockrij>
                              <div class="planbord_rijblok_naam functie naamcel" #naamcel>
                                <ng-container *ngIf="rownr === 0">
                                  <div class="pijlen">
                                    <div class="pijl omhoog" title="Verplaats omhoog" *ngIf="! first"
                                         (click)="verplaatsfunctie(project, index,-1)">
                                      <div><span class="fas fa-arrow-up"></span></div>
                                    </div>
                                    <div class="pijl omlaag" title="Verplaats omlaag" *ngIf="! last"
                                         (click)="verplaatsfunctie(project, index, +1)">
                                      <div><span class="fas fa-arrow-down"></span></div>
                                    </div>
                                    @if (!isLeverancier && magPersoneel && fd.items.length) {
                                      <div class="pijl multi-invulling" title="Bewerk de invulling van meerdere diensten vanaf deze datum" (click)="openMultiInvulling(fd)">
                                        <div><span class="fa fa-ellipsis-h"></span></div>
                                      </div>
                                    }
                                  </div>
                                  <div class="label"> <span class="fas fa-exclamation-triangle text-warning"
                                                            *ngIf="! fd.boekbaar"
                                                            title="Deze functie is niet boekbaar in Exact"></span>
                                    {{ fd.label }}<span class="functionalias"
                                                        *ngIf="fd.functionalias">&emsp;{{ fd.functionalias }}</span>
                                  </div>
                                </ng-container>
                              </div>
                              <ng-container *ngFor="let _datestr of datumstrings; let index=index;">
                                <div class="planbord_rijblok_datum dagblokken" [attr.data-blokindex]="index"
                                >
                                </div>
                              </ng-container>
                              <div class="itemlayer">
                                <div *ngFor="let datestr of datumstrings"
                                     class="datumcontainer projectcel" planblockdag [datestr]="datestr">
                                  <ng-container
                                    *ngIf="(! ux.dragging) && canAddPlanitems && (! project.externe_werkmaatschappij) && datestr >= project.begindatum && ((! project.einddatum) || datestr <= project.einddatum)">
                                    <div class="addblockbtn morning"
                                         [title]="'Voeg dagdienst toe voor ' + project.naam + ': ' + fd.label"
                                         (click)="addPlanItem(project, datestr, 'morning', fd )"><span
                                      class="fas fa-plus-circle"></span></div>
                                    <div class="addblockbtn evening"
                                         [title]="'Voeg avonddienst toe voor ' + project.naam + ': ' + fd.label"
                                         (click)="addPlanItem(project, datestr, 'evening', fd  )"><span
                                      class="fas fa-plus-circle"></span></div>
                                    <div class="addblockbtn night"
                                         [title]="'Voeg nachtdienst toe voor ' + project.naam + ': ' + fd.label"
                                         (click)="addPlanItem(project, datestr, 'night' , fd )"><span
                                      class="fas fa-plus-circle"></span></div>
                                  </ng-container>
                                  <ng-container *ngFor="let planitem of fd.perdate[datestr]">
                                    <planblock *ngIf="(planitem._tags.row === rownr)" [planitem]="planitem"
                                               [weergave]="ux.weergave"
                                               [attr.data-planitem]="planitem.id"
                                               data-display="content"
                                               (edit)="editPlanitem(planitem)"></planblock>
                                  </ng-container>
                                  <div class="commentblock" #commentblock
                                       *ngIf="lastrow && (!! projectcommentVoor(project.id, fd.tag,datestr))"
                                       [class.editable]="canComment"
                                       [attr.title]="projectcommentVoor(project.id, fd.tag,datestr)?.comment"
                                       [style.color]="projectcommentVoor(project.id, fd.tag,datestr)?.voorkleur"
                                       [style.background-color]="projectcommentVoor(project.id, fd.tag,datestr)?.achterkleur"
                                       (click)="editProjectcomment(project.id, fd,datestr)">{{ projectcommentVoor(project.id, fd.tag, datestr)?.comment }}
                                  </div>
                                  <div class="addcomment" title="Voeg commentaar toe"
                                       *ngIf="lastrow && canComment && (! projectcommentVoor(project.id, fd.tag,datestr))"
                                       (click)="editProjectcomment(project.id, fd,datestr)"><span
                                    class="fas fa-comment-dots"></span></div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </div>
                  }
                }
              }
            </ng-container>
          </ng-container>

          <!-- Extra sectie: projecten met externe werkmaatschappijen -->
          @if (externeProjectenVoorWeergave()?.length) {
            <div class="planbord_rijblok klant">
              <div class="planbord_rijblok_hoofdrij">
                <div class="planbord_rijblok_naam klantnaam externe-wm naamcel"
                     [class.open]="ux.klantnaamOpened['Andere werkmaatschappijen']"
                     title="Andere werkmaatschappijen"
                     (click)="toggleKlantnaamOpened('Andere werkmaatschappijen')">Andere werkmaatschappijen
                  <span
                    *ngIf="! ux.projectfilter"
                    class="ml-1 fas"
                    [class.fa-caret-down]="! ux.klantnaamOpened['Andere werkmaatschappijen']"
                    [class.fa-caret-up]="ux.klantnaamOpened['Andere werkmaatschappijen']"></span>
                </div>
                <ng-container *ngFor="let _datestr of datumstrings">
                  <div class="planbord_rijblok_datum dagblokken"></div>
                </ng-container>
              </div>
            </div>

            @if (ux.klantnaamOpened['Andere werkmaatschappijen'] || ux.projectfilter) {
              @for (project of externeProjectenVoorWeergave(); track project.id) {
                <div class="planbord_rijblok project">
                  <div class="planbord_rijblok_hoofdrij">
                    <div class="planbord_rijblok_naam projectnaam naamcel"
                         (click)="toggleProjectOpened(project)"
                         [title]="project.naam">
                      <span class="iconengroep">
                        <span class="fas fa-exclamation-triangle text-warning"
                              *ngIf="project.heeftKritiek"
                              [title]="project.kritiekTekst"></span>
                        <span class="fas fa-building text-info"
                              *ngIf="project.externe_werkmaatschappij"
                              title="Op dit project zie je de diensten uit een andere werkmaatschappij, waarop wij mensen mogen plannen en waarop de uren uiteindelijk worden geschreven en gefactureerd. De bedoeling is dat dit project in Exact goed gekoppeld is aan de andere werkmaatschappij als klant, met de juiste functies in de WBS."></span>
                      </span>
                      <span class="projectlabel">{{ getWerkmaatschappijNaam(project.externe_werkmaatschappij) }}: {{ project.label }}</span>
                      <span
                        *ngIf="project?._tags['functionlist']?.length"
                        class="ml-1 fas"
                        [class.fa-caret-down]="! ux.projectOpened[project.id]"
                        [class.fa-caret-up]="ux.projectOpened[project.id]"></span>
                      <div class="herorderknop" title="Sorteer de functies op naam"
                           *ngIf="ux.projectOpened[project.id] && project._tags['functionlist'].length > 1"
                           (click)="heroderfuncties(project, $event)"><span class="fas fa-sort"></span></div>
                    </div>
                    <ng-container *ngFor="let datestr of datumstrings; let index=index;">
                      <div class="planbord_rijblok_datum dagblokken projectcel"
                           [attr.data-blokindex]="index">
                        <!-- Geen add-knoppen voor externe werkmaatschappij-projecten -->
                      </div>
                    </ng-container>
                  </div>

                  <ng-container *ngIf="ux.projectOpened[project.id]">
                    <ng-container *ngFor="let fd of project._tags['functionlist']; let index = index; let first = first; let last = last;">
                      <ng-container *ngFor="let rownr of fd.rowlist; let lastrow = last;">
                        <div class="planbord_rijblok_subrij" [class.extrarow]="rownr > 0" planblockrij>
                          <div class="planbord_rijblok_naam functie naamcel" #naamcel>
                            <ng-container *ngIf="rownr === 0">
                              <div class="pijlen">
                                <div class="pijl omhoog" title="Verplaats omhoog" *ngIf="! first"
                                     (click)="verplaatsfunctie(project, index,-1)">
                                  <div><span class="fas fa-arrow-up"></span></div>
                                </div>
                                <div class="pijl omlaag" title="Verplaats omlaag" *ngIf="! last"
                                     (click)="verplaatsfunctie(project, index, +1)">
                                  <div><span class="fas fa-arrow-down"></span></div>
                                </div>
                                @if (!isLeverancier && magPersoneel && fd.items.length) {
                                  <div class="pijl multi-invulling" title="Bewerk de invulling van meerdere diensten vanaf deze datum" (click)="openMultiInvulling(fd)">
                                    <div><span class="fa fa-ellipsis-h"></span></div>
                                  </div>
                                }
                              </div>
                              <div class="label"> <span class="fas fa-exclamation-triangle text-warning"
                                                    *ngIf="! fd.boekbaar"
                                                    title="Deze functie is niet boekbaar in Exact"></span>
                                {{ fd.label }}<span class="functionalias"
                                                    *ngIf="fd.functionalias">&emsp;{{ fd.functionalias }}</span>
                              </div>
                            </ng-container>
                          </div>
                          <ng-container *ngFor="let _datestr of datumstrings; let index=index;">
                            <div class="planbord_rijblok_datum dagblokken" [attr.data-blokindex]="index">
                            </div>
                          </ng-container>
                          <div class="itemlayer">
                            <div *ngFor="let datestr of datumstrings"
                                 class="datumcontainer projectcel" planblockdag [datestr]="datestr">
                              <ng-container *ngFor="let planitem of fd.perdate[datestr]">
                                <planblock *ngIf="(planitem._tags.row === rownr)" [planitem]="planitem"
                                           [weergave]="ux.weergave"
                                           [attr.data-planitem]="planitem.id"
                                           data-display="content"
                                           (edit)="editPlanitem(planitem)"></planblock>
                              </ng-container>
                              <div class="commentblock" #commentblock
                                   *ngIf="lastrow && (!! projectcommentVoor(project.id, fd.tag,datestr))"
                                   [class.editable]="canComment"
                                   [attr.title]="projectcommentVoor(project.id, fd.tag,datestr)?.comment"
                                   [style.color]="projectcommentVoor(project.id, fd.tag,datestr)?.voorkleur"
                                   [style.background-color]="projectcommentVoor(project.id, fd.tag,datestr)?.achterkleur"
                                   (click)="editProjectcomment(project.id, fd,datestr)">{{ projectcommentVoor(project.id, fd.tag, datestr)?.comment }}
                              </div>
                              <div class="addcomment" title="Voeg commentaar toe"
                                   *ngIf="lastrow && canComment && (! projectcommentVoor(project.id, fd.tag,datestr))"
                                   (click)="editProjectcomment(project.id, fd,datestr)"><span
                                class="fas fa-comment-dots"></span></div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              }
            }
          }
        }
        @case ('invulling') {
          <!-- Weergave MEDEWERKER (invulling) -->
          <ng-container *ngFor="let groep of ux.actieveGroepen">
            <div class="planbord_rijblok groep" *ngIf="(! ux.leverancierfilter)">
              <div class="planbord_rijblok_hoofdrij">
                <div class="planbord_rijblok_naam groepnaam naamcel"
                     (click)="toggleGroepOpened(groep)"
                >{{ groep }}
                  <span class="ml-1 fas" [class.fa-caret-down]="! ux.groepOpened[groep]"
                        [class.fa-caret-up]="ux.groepOpened[groep]"></span>
                </div>
                <ng-container *ngFor="let _datestr of datumstrings">
                  <div class="planbord_rijblok_datum dagblokken"></div>
                </ng-container>
              </div>
            </div>
            <ng-container *ngIf="ux.leverancierfilter || ux.groepOpened[groep]">
              <ng-container *ngFor="let person of personeeldata">
                <ng-container
                  *ngIf="weergaveMedewerkerFilterPersoneel(person,groep)">
                  <div class="planbord_rijblok personeel" [attr.data-pid]="person.id">
                    <div class="planbord_rijblok_subrij" planblockrij>
                      <div class="planbord_rijblok_naam naamcel" #naamcel>
                        <div class="personeel_info"><!-- 1 div om te centreren-->
                          <div class="personeel_naam" title="Naam - Klik om te kopiëren"
                               (click)="kopieerNaarKlembord(person.naam)">{{ person.naam }}
                          </div>
                          @if (person.telefoonnummer?.length) {
                            <div title="Telefoonnummer - Klik om te kopiëren"
                                 (click)="kopieerNaarKlembord(person.telefoonnummer)">{{ person.telefoonnummer }}
                            </div>
                          }
                          @if (person.email?.length) {
                            <div title="E-mailadres - Klik om te kopiëren" (click)="kopieerNaarKlembord(person.email)">{{ person.email }}
                            </div>
                          }
                          @if (person.woonplaats?.length) {
                            <div class="personeel_woonplaats"
                                 title="Woonplaats - Klik om te kopiëren"
                                 (click)="kopieerNaarKlembord(person.woonplaats)">{{ person.woonplaats }}
                            </div>
                          }
                        </div>
                      </div>
                      <div class="planbord_rijblok_datum dagblokken" [attr.data-blokindex]="index"
                           *ngFor="let _datestr of datumstrings; let index=index;">
                      </div>
                      <div class="itemlayer">
                        <div *ngFor="let datestr of datumstrings"
                             class="datumcontainer" planblockdag [datestr]="datestr">
                          <ng-container *ngFor="let planitem of person._tags['itemsperdate'][datestr]">
                            <planblock [planitem]="planitem"
                                       [weergave]="ux.weergave"
                                       (edit)="editPlanitem(planitem)"></planblock>
                          </ng-container>
                          <div class="commentblock" #commentblock
                               *ngIf="!! personeelcommentVoor(person.id,datestr)"
                               [class.editable]="canComment"
                               [attr.title]="personeelcommentVoor(person.id,datestr)?.comment"
                               [style.color]="personeelcommentVoor(person.id,datestr)?.voorkleur"
                               [style.background-color]="personeelcommentVoor(person.id,datestr)?.achterkleur"
                               (click)="editPersoneelcomment(person.id, datestr)">{{ personeelcommentVoor(person.id, datestr)?.comment }}
                            <span
                              *ngIf="personeelcommentVoor(person.id,datestr)?._tags['afwezig']?.length"> ({{ personeelcommentVoor(person.id, datestr)?._tags['afwezig'] }}
                              )</span>
                          </div>
                          <div class="addcomment" title="Voeg commentaar toe"
                               *ngIf="canComment && (! personeelcommentVoor(person.id,datestr))"
                               (click)="editPersoneelcomment(person.id, datestr)"><span
                            class="fas fa-comment-dots"></span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        }
        @case ('invulling_planning') {
          <!-- Weergave INVULLEN -->
          @for (person of personeeldata; track person.id; ) {
            <!-- Alleen personneel met mogelijkheden -->
            @if (weergaveInvullenFilterPersoneel(person)) {
              <div class="planbord_rijblok personeel">
                <ng-container *ngFor="let rownr of person._tags.invulrijlijst">
                  <div class="planbord_rijblok_subrij" [class.extrarow]="rownr > 0" planblockrij>
                    <div class="planbord_rijblok_naam naamcel" #naamcel>
                      @if (rownr === 0) {
                        <div class="personeel_info"><!-- 1 div om te centreren-->
                          <div class="personeel_naam" title="Naam - Klik om te kopiëren"
                               (click)="kopieerNaarKlembord(person.naam)">{{ person.naam }}
                          </div>
                          @if (person.telefoonnummer?.length) {
                            <div title="Telefoonnummer - Klik om te kopiëren"
                                 (click)="kopieerNaarKlembord(person.telefoonnummer)">{{ person.telefoonnummer }}
                            </div>
                          }
                          @if (person.email?.length) {
                            <div title="E-mailadres - Klik om te kopiëren" (click)="kopieerNaarKlembord(person.email)">{{ person.email }}
                            </div>
                          }
                          @if (person.woonplaats?.length) {
                            <div class="personeel_woonplaats"
                                 title="Woonplaats - Klik om te kopiëren"
                                 (click)="kopieerNaarKlembord(person.woonplaats)">{{ person.woonplaats }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <div class="planbord_rijblok_datum dagblokken" [attr.data-blokindex]="index"
                         *ngFor="let _datestr of datumstrings; let index=index;">
                    </div>
                    <div class="itemlayer">
                      <div *ngFor="let datestr of datumstrings;"
                           class="datumcontainer" planblockdag [datestr]="datestr">
                        <ng-container *ngFor="let planitem of person._tags['mogelijke_itemsperdate'][datestr]">
                          <planblock
                            *ngIf="!! ((planitem._tags.invulrij[person.id] === rownr) && (planitem.implementationDegree < 0))"
                            [planitem]="planitem"
                            weergave="invulling_planning"
                            (addremove)="planitemAddRemove(planitem, person,true)"
                            [virtueel]="true"></planblock>
                        </ng-container>
                        <ng-container *ngFor="let planitem of person._tags['itemsperdate'][datestr]">
                          <planblock *ngIf="planitem._tags.invulrij[person.id] === rownr" [planitem]="planitem"
                                     (addremove)="planitemAddRemove(planitem, person,false)"
                                     weergave="invulling_planning"></planblock>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            }
          }
        }
      }
    </div>
  </div>
  <div class="planbordfooter">
    <div class="container-fluid overflow-hidden" fullheight>
      <div class="row" fullheight>
        <div class="w-col-lg">
          <div class="weergavetools">
            <div class="herlaadknop wtsub" [hidden]="! dataGewijzigd">
              <button class="btn btn-outline-primary"
                      title="De gegevens zijn inmiddels gewijzigd. Herlaad de data in dit scherm door op deze knop te klikken."
                      (click)="reloadKnop()"><span class="fas fa-sync"></span></button>
            </div>
            <div class="vrijedatum wtsub">
              <!--datarangepicker placement kan wel degelijk top left aan, alleen zijn typedefinitie kent
                  die combinatie niet: vandaar de $any. Met alleen "top" valt de helft buiten beeld.-->
              <input type="text"
                     [disabled]="ux.weergave === 'invulling_planning'"
                     class="form-control novalidationfeedback"
                     bsDaterangepicker
                     [bsConfig]="{ isAnimated: true, adaptivePosition: false}"
                     [placement]="$any('top left')"
                     [(ngModel)]="ux.daterange"
                     (ngModelChange)="setFreeDaterange()"
              >
            </div>
            <div class="btn-group bladeren wtsub">
              <button type="button" class="terug-button btn btn-outline-primary" (click)="schuifBegindatum(-1)">
                <span class="fas fa-angle-left"></span></button>
              <button type="button" class="nu-button btn btn-primary" (click)="begindatumNu()">Nu</button>
              <button type="button" class="vooruit-button btn btn-outline-primary" (click)="schuifBegindatum(1)">
                <span class="fas fa-angle-right"></span></button>
            </div>
            <div class="periode_select wtsub">
              <select [id]="id('periode')" name="periode" [(ngModel)]="datumbereik" aria-label="Kies een periode"
                      (change)="switchPeriode()" [disabled]="ux.weergave === 'invulling_planning'">
                <option [ngValue]="0" *ngIf="datumbereik === 0">vrije keuze</option>
                <option *ngFor="let periode of datumBereikLijst" [ngValue]="periode.dagen">{{ periode.waarde }}</option>
              </select>
            </div>

            @if (volLezen || magPersoneel) {
              <!-- We hoeven de weergaveswitch niet af te beelden als er toch maar 1 knop is -->
              <div class="btn-group btn-group-toggle weergave wtsub">
                <button class="btn btn-primary" [class.active]="ux.weergave==='project'"
                        (click)="setWeergave('project')">
                  Diensten
                </button>
                <button *ngIf="volLezen" class="btn btn-primary" [class.active]="ux.weergave==='invulling'"
                        (click)="setWeergave('invulling')">
                  Medewerker
                </button>
                <button *ngIf="magPersoneel" class="btn btn-primary"
                        [class.active]="ux.weergave === 'invulling_planning'"
                        (click)="setWeergave('invulling_planning')">
                  Invullen
                </button>
              </div>
            }
            <div class="projectselect wtsub" *ngIf="ux.weergave === 'project'">
              <ng-select [(ngModel)]="ux.projectfilter"
                         [id]="id('projectfilter')"
                         dropdownPosition="top"
                         name="projectfilter"
                         [appendTo]="dropdownContainer"
                         placeholder="(Projecten met planning)">
                <ng-container *ngFor="let project of projectdata">
                  <!-- Alleen van juiste type. Switch van type regelt hier de reset -->
                  <ng-option [value]="project.id">{{ project.label }}</ng-option>
                </ng-container>
              </ng-select>
            </div>
            @if (magFilteren) {
              <div class="wtsub">
                <button class="btn" [ngClass]="heeftActiefFilter ? 'btn-info' : 'btn-outline-secondary'" title="Open Filtertool" (click)="openFiltertool()">
                  <span class="fas fa-filter"></span>
                </button>
              </div>
              <div class="wtsub d-flex align-items-center">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" [id]="id('filteractief')" [(ngModel)]="ux.filterActief" (ngModelChange)="filterActiefGewijzigd()">
                  <label class="custom-control-label" [for]="id('filteractief')" title="Schakel toepassen van filters aan of uit">Filter toepassen</label>
                </div>
              </div>
            }
            <div class="wtsub"
                 *ngIf="ux.weergave === 'invulling_planning' || ux.weergave === 'invulling'">
              <select [(ngModel)]="ux.leverancierfilter" [id]="id('leverancierfilter')" name="leverancierfilter">
                <option [ngValue]="null">* Alle medewerkers</option>
                <option [ngValue]="-1">* Eigen personeel</option>
                <option [ngValue]="-2">* ZZP-Pool</option>
                <option [ngValue]="-3">* ZZP</option>
                <option [ngValue]="-4">* Extern</option>
                <!-- Of leverancier -->
                <ng-container *ngFor="let leverancier of leverancierlijst">
                  <ng-container
                    *ngIf="leverancier.leverancierstype === 'Inhuur' && ((ux.weergave === 'invulling' && leverancier._tags.heeft_pi) || (ux.weergave === 'invulling_planning' && leverancier._tags.heeft_mogelijke_pi))">
                    <option [ngValue]="leverancier.id">{{ leverancier.naam }}</option>
                  </ng-container>
                </ng-container>
              </select>
            </div>
            <div class="wtsub" *ngIf="verwijderdeItems.length > 0">
              <button class="btn btn-primary" (click)="openVerwijderdePlanitems()">Verwijderde diensten...</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
